import axios from '../config/axios';

const API_URL = '/api/upload';

export const uploadFile = async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('images', file);

    try {
        const response = await axios.post(API_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response.data && response.data.images && response.data.images.length > 0) {
            return response.data.images[0];
        } else {
            throw new Error('No image URL returned from server');
        }
    } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
    }
};
